import React, { PureComponent } from 'react'
import { Row, Panel } from 'react-bootstrap'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import { Field } from 'redux-form'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import { permissions } from '../../../constants/backendIds'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import CustomFields from '../../commons/customFields/CustomFields'

class OtherData extends PureComponent {
  constructor () {
    super()
    this.state = {
      open: false,
      fieldsConfiguration: {
        vehicleTypeId: null,
        activityBuyer: null
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.open) {
      this.setState({ open: true })
    }
  }

  UNSAFE_componentWillMount () {
    this.initializePermisions(this.props)
  }

  fetchSalesDossierPromiseOtherDataHistorical () {
    if (this.state.open) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({
      open: !this.state.open
    })
    if (this.props.isOtherDataLoaded === false) {
      return new Promise((resolve, reject) => {
        this.props.handleToUpdateComponent(this.props)
        if (this.props.dossierType === dossierTypesConstant.sales) {
          return this.props.actions.fetchSalesOtherDataHistorical(this.props.dossierId, resolve, reject, this.props.pristine)
        } else if (this.props.dossierType === dossierTypesConstant.purchase) {
          return this.props.actions.fetchPurchaseOtherDataHistorical(this.props.dossierId, resolve, reject, this.props.pristine)
        }
      })
    }
  }

  render () {
    const {
      t, dossierType, showEconomicPlan, customFields,
      combos: {
        ivaTypeCombo, paymentMethodPurchase, laterUseCombo, vehicleType, previousUsageCombo,
        activityClientCombo, activityBuyerCombo
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.'

    return (
      <div className={dossierType === dossierTypesConstant.purchase ? ('other-data-panel dossier-panel') : 'dossier-panel'}>
        <div className="header-panel" onClick={this.fetchSalesDossierPromiseOtherDataHistorical.bind(this)}>
          <div className="name-wrapper">
            <i className="ico-comment" />
            <h4>{t(`${tKey}OTHER_DATA.TITLE_PANEL`)}</h4>
          </div>
          <i className={this.state.open ? 'ico-arrow-black-up' : 'ico-arrow-black-down'} />
        </div>
        <Panel expanded={this.state.open} onToggle={() => {}}>
          <Panel.Collapse>
            {
              dossierType === dossierTypesConstant.purchase ? (
                <Row>
                  <Field
                    id="additionalClauses"
                    name="dossierCompleteOtherDataComponent.additionalClauses"
                    colSm={4}
                    controlLabel={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    placeholder={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    component={InputText}
                    disabled={true}
                    forceControlLabelInOneLine={true}
                  />
                  <Field
                    colSm={4}
                    id="previousUsageId"
                    name="dossierCompleteOtherDataComponent.previousUsageId"
                    controlLabel={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    placeholder={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    component={InputSelect}
                    options={previousUsageCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  <Field
                    colSm={4}
                    id="laterUseId"
                    name="dossierCompleteOtherDataComponent.laterUseId"
                    controlLabel={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    placeholder={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    component={InputSelect}
                    options={laterUseCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  <Field
                    colSm={4}
                    id="vehicleTypeId"
                    name="dossierCompleteOtherDataComponent.vehicleTypeId"
                    controlLabel={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    placeholder={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    component={InputSelect}
                    options={vehicleType}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  <Field
                    colSm={4}
                    id="activityClient"
                    name="dossierCompleteOtherDataComponent.activityClientId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    component={InputSelect}
                    options={activityClientCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  {this.state.fieldsConfiguration.activityBuyer && this.state.fieldsConfiguration.activityBuyer.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="activityBuyer"
                    name="dossierCompleteOtherDataComponent.activityBuyerId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_BUYER`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_BUYER`)}
                    component={InputSelect}
                    options={activityBuyerCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />)}
                  <Field
                    colSm={4}
                    id="paymentMethodPurchaseId"
                    name="dossierCompleteOtherDataComponent.paymentMethodPurchaseId"
                    controlLabel={t(`${tKey}OTHER_DATA.PAYMENT_METHOD`)}
                    placeholder={t(`${tKey}OTHER_DATA.PAYMENT_METHOD`)}
                    component={InputSelect}
                    options={paymentMethodPurchase}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  <Field
                    colSm={4}
                    id="ivaTypeId"
                    name="dossierCompleteOtherDataComponent.ivaTypeId"
                    controlLabel={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                    placeholder={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                    component={InputSelect}
                    options={ivaTypeCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                </Row>
              ) : (dossierType === dossierTypesConstant.sales ? (
                <Row>
                  <Field
                    id="additionalClauses"
                    name="dossierCompleteOtherDataComponent.additionalClauses"
                    colSm={4}
                    controlLabel={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    placeholder={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    component={InputText}
                    disabled={true}
                    forceControlLabelInOneLine={true}
                  />
                  <Field
                    colSm={4}
                    id="previousUsageId"
                    name="dossierCompleteOtherDataComponent.previousUsageId"
                    controlLabel={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    placeholder={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    component={InputSelect}
                    options={previousUsageCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  <Field
                    colSm={4}
                    id="laterUseId"
                    name="dossierCompleteOtherDataComponent.laterUseId"
                    controlLabel={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    placeholder={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    component={InputSelect}
                    options={laterUseCombo}
                    disabled={true}
                    valueKey="id"
                    labelKey="value"
                  />
                  {this.state.fieldsConfiguration.vehicleTypeId && this.state.fieldsConfiguration.vehicleTypeId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="vehicleTypeId"
                    name="dossierCompleteOtherDataComponent.vehicleTypeId"
                    controlLabel={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    placeholder={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    component={InputSelect}
                    options={vehicleType}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />)}
                  <Field
                    colSm={4}
                    id="activityClient"
                    name="dossierCompleteOtherDataComponent.activityClientId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    component={InputSelect}
                    options={activityClientCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={true}
                  />
                  {!showEconomicPlan && (
                    <Field
                      colSm={4}
                      id="ivaTypeId"
                      name="dossierCompleteOtherDataComponent.ivaTypeId"
                      controlLabel={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                      placeholder={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                      component={InputSelect}
                      options={ivaTypeCombo}
                      disabled={true}
                      valueKey="id"
                      labelKey="value"
                    />
                  )}
                </Row>
              ) : null
              )
            }
            <CustomFields customFields={customFields} readOnlyFields={true} />
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}
export default OtherData
